import { createSelector } from "reselect";
import { csvImportSelector } from "../csv_import_selector";

export const csvImportsLoadStateSelector = createSelector(
  csvImportSelector,
  csvImport => {
    return csvImport.loadState;
  }
);
